import { collectionEngineV1 } from '../apis.js';
const criiptoAPI = collectionEngineV1('/criipto', false);
export const auth = (tenantId, code, redirectURL, details) => criiptoAPI('GET', `/${code}?tenantId=${tenantId}&redirectURL=${encodeURIComponent(redirectURL)}${details
    ? `&details=${encodeURIComponent(encodeURIComponent(JSON.stringify(details)))}`
    : ''}`);
//# sourceMappingURL=criipto.js.map